import { themeColor, themeFontFamily } from 'LibNeo/theme'
import styled from 'styled-components'
import { LinkComponentStyled } from 'LibNeo/components/Basic/Link/styled'
import { IconComponent } from 'LibNeo'

export const LabelWrapper = styled.span`
	font-size: 12px;
	line-height: 20px;
	padding: 0;
	white-space: nowrap;
	display: inline-block;
	width: fit-content;
	font-family: ${themeFontFamily('SBSansInterface')};
	font-style: normal;
	font-weight: 400;
	color: ${themeColor('gray', 5)};

	&:not(:nth-of-type(1)) {
		margin-right: 8px;
	}
	ul {
		padding: 0;
		margin: 0;
		list-style: none;
	}
`
export const Icon = styled(IconComponent)`
	margin: 0 0 0 4px;
`
export const Wrapper = styled.div`
	display: flex;
	height: 20px;
	margin: 0 0 4px 0;
	align-items: flex-start;
	${LinkComponentStyled} {
		text-decoration: underline dotted;
		margin: 0 0 0 auto;
	}
`
export const RequiredIcon = styled.span`
	color: ${themeColor('magenta')};
	padding: 0 0 0 4px;
`
